/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `GB 388225173` - UK
* `EL 996599482` - GREECE
 */
export type SafiVatEnum = typeof SafiVatEnum[keyof typeof SafiVatEnum];


export const SafiVatEnum = {
  GB_388225173: 'GB 388225173',
  EL_996599482: 'EL 996599482',
} as const;
